const InputText: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = (props) => {
    return (
        <input
            {...props}
            className={`
                h-[45px]
                px-3

              disabled:bg-gray-100 disabled:text-zinc-700
                
                border outline-none rounded
            `.concat(props.className || '')}

        />
    )
}

export default InputText